import { ReactNode, useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { useUserProfileStore } from 'app/railways/domains/profile/features/user-profile-data';

import { UPermissionsName } from '../../../core/permissions';

type CanAccessProps = {
  perm: UPermissionsName | '*' | Array<UPermissionsName>;
  children: ReactNode;
  fallback?: ReactNode;
};
export const CanAccess = observer(
  ({ perm, children, fallback }: CanAccessProps) => {
    const userProfileStore = useUserProfileStore();

    if (perm === '*') return <>{children}</>;

    const hasAccess = useMemo(() => {
      const featurePerms = typeof perm === 'string' ? [perm] : perm;
      const result = featurePerms.every((p) => userProfileStore.perms.has(p));

      return result;
    }, [perm, userProfileStore.perms]);

    if (fallback) {
      return hasAccess ? <>{children}</> : <>{fallback}</>;
    }

    return hasAccess ? <>{children}</> : null;
  },
);
